import { Asset } from 'react-native-image-picker';
import { IconProps } from '../../Icon/Icon.types';
import { ScrollViewProps } from '../../ScrollView/ScrollView.types';

export const IMAGE_FORMAT_ICONS: Record<
  Required<Asset>['type'],
  IconProps['name']
> = {
  ['image/png']: 'png',
  ['image/heic']: 'heic',
  ['image/jpg']: 'jpg',
  ['image/jpeg']: 'jpeg',
};

export const CONTENT_CONTAINER_STYLE: Required<ScrollViewProps>['contentContainerStyle'] =
  {
    gap: 'space-400',
    justifyContent: 'center',
    minWidth: '100%',
  };
